/**
 * CartService utilities (Angular 18)
 *
 * Mirrors: apps/b2b-ui/common/services/cart/cart.service.utils.ts
 */
import { CartFormItem, CartOrderForm } from '@b2b/types/cart';
import { CartEventOrderForm } from '@b2b/types/event';
import { CartMembershipOrderForm, isMembershipOrderForm } from '@b2b/types/membership';
import { v4 as uuidv4 } from 'uuid';

/**
 * Converts a resolved CartOrderForm (event or membership) into a CartFormItem
 * suitable for storing in the cart's `model.forms` array.
 */
export function cartOrderFormToCartFormItem(form: CartOrderForm): CartFormItem {
  if (isMembershipOrderForm(form)) {
    const membershipForm = form as CartMembershipOrderForm;
    return {
      itemUUID: uuidv4(),
      uuid: uuidv4(),
      formId: membershipForm.id,
      itemId: membershipForm.membershipOfferingId ?? '',
      itemName: membershipForm.membershipName,
      itemType: membershipForm.itemType,
      oncePerCart: membershipForm.oncePerCart,
      formCategoryType: membershipForm.formCategoryType,
      formDisplaySettings: membershipForm.formDisplaySettings,
      formResponseId: null,
    };
  }

  const eventForm = form as CartEventOrderForm;
  return {
    itemUUID: uuidv4(),
    uuid: uuidv4(),
    formId: eventForm.id,
    itemId: eventForm.event.id,
    itemName: eventForm.event.name,
    itemType: eventForm.itemType,
    oncePerCart: eventForm.oncePerCart,
    formCategoryType: eventForm.formCategoryType,
    formDisplaySettings: eventForm.formDisplaySettings,
    formResponseId: null,
  };
}
